// extracted by mini-css-extract-plugin
module.exports = {"placeholder-container-student":"QuestionPlaceholder_placeholder-container-student_2FEVz","question-header":"QuestionPlaceholder_question-header_nDVQC"};